import React from 'react';
import { Box, Typography } from '@mui-core-real';
import { createStyles, makeStyles } from '@mui-core-real/styles';
import { CANCEL_CASE_MODAL } from '@components/Modal/modalConstants';
import { CancelCaseModalInfoProps } from '@components/CancelCase/CancelCaseModalTypes';
import DisplaySelectedUnitTimeFrame from '@components/SchedulePage/DisplaySelectedUnitTimeFrame/DisplaySelectedUnitTimeFrame';
import { dateParse, formatLongDate } from '@utilities/dateUtilities';
import { addMinutes } from 'date-fns';

const useStyles = makeStyles((theme) =>
	createStyles({
		infoWrapper: {
			display: 'flex',
			flexDirection: 'column',
			gap: theme.spacing(3),
		},
		eventInfoDetails: {
			color: theme.palette.grey[600],
			fontWeight: 600,
		},
		text: {
			letterSpacing: '0.25px',
		},
		requiredText: {
			color: theme.palette.error.main,
		},
	}),
);

export const CancelCaseModalInfo = ({
	surgeonName,
	hospitalName,
	surgeryDate,
	duration,
	unit,
	patientName,
}: CancelCaseModalInfoProps) => {
	const classes = useStyles();
	const { title, message } = CANCEL_CASE_MODAL;

	const [date] = dateParse(surgeryDate);
	const procedureDate = formatLongDate(date);

	const timeframes = {
		start: new Date(surgeryDate),
		end: duration
			? addMinutes(new Date(surgeryDate), parseInt(duration))
			: undefined,
	};

	return (
		<Box className={classes.infoWrapper}>
			<Typography className={classes.text} component="h1" variant="h6">
				{title}
			</Typography>

			<Box>
				<Typography className={classes.eventInfoDetails} variant="body1">
					{surgeonName}
				</Typography>
				<Typography className={classes.eventInfoDetails} variant="body1">
					{patientName}
				</Typography>
				<Typography className={classes.eventInfoDetails} variant="body1">
					{procedureDate}
				</Typography>
				<DisplaySelectedUnitTimeFrame
					timeFrame={timeframes}
					variant="body1"
					className={classes.eventInfoDetails}
				/>
				<Typography className={classes.eventInfoDetails} variant="body1">
					{hospitalName} | {unit}
				</Typography>
			</Box>

			<Typography className={classes.eventInfoDetails} variant="body1">
				{message}
			</Typography>
			<Typography className={classes.requiredText}>
				* Indicates required fields
			</Typography>
		</Box>
	);
};
